module.exports = __webpack_public_path__ + "static/media/ic_local_phone_24px.65d10477.svg";